export default __webpack_public_path__ + "static/2199-57c8135f25f9f43c6a92b1a991f4c08e.gif";